/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An iQEnergy object
 */
export interface AddressV0 { 
    /**
     * 
     */
    address1?: string;
    /**
     * 
     */
    address2?: string;
    /**
     * 
     */
    address3?: string;
    /**
     * 
     */
    address4?: string;
    /**
     * 
     */
    town?: string;
    /**
     * 
     */
    postcode?: string;
    /**
     * 
     */
    country?: string;
    /**
     * 
     */
    uprn?: string;
    /**
     * The `RdSAP Assessment Report` for the property address
     */
    tempId: string;
    /**
     * 
     */
    addressLine?: string;
}

